export const GET_DASHBOARD_STATS_SAGA = 'GET_DASHBOARD_STATS_SAGA';
export const GET_DASHBOARD_STATS_START = 'GET_DASHBOARD_STATS_START';
export const GET_DASHBOARD_STATS_SUCCESS = 'GET_DASHBOARD_STATS_SUCCESS';
export const GET_DASHBOARD_STATS_FAIL = 'GET_DASHBOARD_STATS_FAIL';